import { render, staticRenderFns } from "./SimilarContractsModal.vue?vue&type=template&id=2e0b86d8"
import script from "./SimilarContractsModal.vue?vue&type=script&lang=ts"
export * from "./SimilarContractsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports